'use strict';

var curry = require('./curry.js');
require('./always.js');
require('./_branch.js');
require('./branch.js');
require('./id.js');
require('./chunk-ba04ad2f.js');
require('./chunk-d7703e54.js');
require('./variadic.js');
require('./compose.js');
require('./_append.js');
require('./append.js');
require('./flip.js');
require('./chunk-56a5551b.js');
require('./chunk-e6d921c6.js');
require('./chunk-ac19a55d.js');
require('./concat.js');
require('./_concatMap.js');
var _filter = require('./_filter.js');

/**
 * Filters a list using a predicate function.
 *
 * @function
 * @param {Function} p The predicate function.
 * @param {Array|String} as The list to filter.
 * @returns {Array|String} A list that contains only the elements in the list
 * of `as` that satisfy the predicate function `p`.
 * @example
 *
 * import { eq, filter, gt } from 'fkit'
 * filter(gt(1), [1, 2, 3]) // [2, 3]
 * filter(eq('o'), 'foo') // 'oo'
 */

var filter = curry(_filter);

module.exports = filter;
